export const ReflectedStatusValues = ['non-reflect', 'reflected'] as const;
export type ReflectedStatusTuple = typeof ReflectedStatusValues;
export type ReflectedStatus = ReflectedStatusTuple[number];
